export enum VariationType {
  MyCC = 'MyCareerChoices',
  EQ = 'EirQuest',
  TQ = 'TurQuest',
  CQ = 'CymruQuest',
}
